export const GET_LOADING_STATUS = "getLoadingStatus";
